import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import YouTubeVideoList from "../../components/Entertainment/YouTubeVideoList";
import MovieList from "../../components/Entertainment/Movie";

function Entertainment() {
  const [entertainmentNews, setEntertainmentNews] = useState([]);
  const [gossipNews, setGossipNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const [entertainmentData, gossipData] = await Promise.all([
        fetchNewsByCategory("entertainment"),
        fetchNewsByCategory("gossip"),
      ]);

      setEntertainmentNews(entertainmentData);
      setGossipNews(gossipData);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <MovieList />
          <NewsSection
            title="Celebrity News"
            articles={gossipNews}
            category="gossip"
          />
        </div>
        <YouTubeVideoList />
        {/* Gossip Section */}
        <NewsSection
          title="Entertainment News"
          articles={entertainmentNews}
          category="entertainment"
        />
      </div>
    </>
  );
}

export default Entertainment;
